import { render, staticRenderFns } from "./PaymentTypeItem.vue?vue&type=template&id=6f1804b9&scoped=true"
import script from "./PaymentTypeItem.vue?vue&type=script&lang=js"
export * from "./PaymentTypeItem.vue?vue&type=script&lang=js"
import style0 from "./PaymentTypeItem.vue?vue&type=style&index=0&id=6f1804b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1804b9",
  null
  
)

export default component.exports